import { useCallback } from 'react';
import { useAxios } from '../axios';
import { repeatArraySerializer } from '../utils';
import { Job, JobQueryParams } from './jobs.types';

export const useGetJobs = () => {
  const [{ data, loading }, getJobsReq] = useAxios<{
    result: { data: Job[]; count: number };
  }>({
    method: 'GET',
  });

  const getJobs = useCallback(
    ({
      filterText = '',
      pageNumber = 1,
      resultSize = 10,
      jobStatus = [],
    }: JobQueryParams) =>
      getJobsReq({
        url: '/job',
        params: {
          filterText,
          pageNumber,
          resultSize,
          ...(jobStatus.length && {
            status: jobStatus,
          }),
        },
        paramsSerializer: repeatArraySerializer,
      }),
    [getJobsReq],
  );

  const jobs = data?.result?.data;
  const count = data?.result?.count;

  return {
    data: jobs && typeof count === 'number' ? { jobs, count } : undefined,
    loading,
    getJobs,
  };
};
